import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FocusGroup from "@/pages/FocusGroup";

export const Route = createFileRoute("/focus-group")({
  head: () => seoHead("/focus-group"),
  component: FocusGroup,
});
